import { memoizeFunction, isFunction } from '@agilepoint/utils-common';
import { IMaskInfo, IPlaceholderInfo, IMaskSegmentInfo } from './masked-input-types';

export const getPlaceholderInfo = memoizeFunction((masks: IMaskInfo[] = []) => masks.reduce((info, m) => {
    info.length += (m.placeholder?.length ?? m.fixedContent?.length ?? 1);
    info.placeholder += ((m.placeholder || m.fixedContent) ?? '');
    return info;
}, { placeholder: '', length: 0 } as IPlaceholderInfo));


export const defaultTransformFunction = (value: string) => value;

export function validateMask(key: string, value: string, maskInfo: IMaskSegmentInfo) {
    const { mask: { fixedContent, pattern, validate } } = maskInfo;
    if (isFunction(validate)) {
        return validate(key, value, maskInfo);
    }

    if (fixedContent) {
        return key === fixedContent;
    }

    if (pattern) {
        const regexp = new RegExp(pattern);
        return regexp.test(key);
    }

    return false;
}

export function getMaskSegmentInfo(masks: IMaskInfo[], index: number) {
    let tempIdx = 0;
    let maskSegmentInfo: IMaskSegmentInfo | undefined;
    masks.some((mask, idx) => {
        const { fixedContent } = mask;
        const maskLength = fixedContent ? fixedContent.length : 1;
        if (index < tempIdx || (index >= (tempIdx + maskLength))) {
            tempIdx += maskLength;
            return false;
        }
        maskSegmentInfo = {
            mask,
            endIndex: index + maskLength,
            startIndex: index,
            maskIndex: idx
        };
        return true;
    });
    return maskSegmentInfo;
}

export function getFixedContent(masks: IMaskInfo[], index: number) {
    const maskSegmentInfo = getMaskSegmentInfo(masks, index);
    let fixedContent = '';
    if (!maskSegmentInfo) {
        return fixedContent;
    }
    let { maskIndex } = maskSegmentInfo;
    let mask = masks[maskIndex];
    while (mask.fixedContent) {
        fixedContent += mask.fixedContent;
        mask = masks[++maskIndex];
    }
    return fixedContent;
}

export function getNextFixedContent(masks: IMaskInfo[], index: number) {
    if (masks.length === 0) {
        return '';
    }

    const maskSegmentInfo = getMaskSegmentInfo(masks, index);
    if (!maskSegmentInfo) {
        return '';
    }

    const nextMask = masks[maskSegmentInfo.maskIndex + 1];
    return nextMask?.fixedContent ?? '';
}
